import { BlockWrapper, defineBlock } from "@smartfire/js-block-engine";
import style from "./block.module.scss";
import background from "../assets/images/bg-introduction.png";
import { ReactComponent as LogoAeon } from "../assets/images/logo.svg";
import { ReactComponent as LogoAlpeHuez } from "../assets/images/alpeHuez.svg";
import { ReactComponent as Logo2Alpes } from "../assets/images/2Alpes.svg";
import { ReactComponent as LogoGrave } from "../assets/images/laGrave.svg";
import { useEffect, useState } from "react";

function Block() {
  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const referrer = document.referrer;
    const isExternalReferrer =
      !referrer || new URL(referrer).origin !== window.location.origin;

    setShouldDisplay(isExternalReferrer);
  }, []);

  if (!shouldDisplay) {
    return null; // Ne pas afficher le composant si la condition n'est pas remplie
  }

  return (
    <BlockWrapper.Div
      className={style.block}
      style={{ backgroundImage: `url(${background})` }}
    >
      <div>
        <div className={style.logoAeon}>
          <LogoAeon />
        </div>
        <div className={style.logosStation}>
          <LogoAlpeHuez className={style.huez} />
          <Logo2Alpes className={style.alpes} />
          <LogoGrave className={style.grave} />
        </div>
      </div>
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Introduction",
  },
});
